import { create } from 'zustand';

export interface AuthUser {
  id: number;
  username: string;
  name: string;
  role: string;
  email: string | null;
  position: string | null;
  rank: string | null;
  department_id: number | null;
  department_name: string | null;
  as_team_id: number | null;
  is_active: boolean;
  position_order: number | null;
  can_post_notice: boolean;
}

interface AuthState {
  accessToken: string | null;
  user: AuthUser | null;
  isAuthenticated: boolean;
  isInitialized: boolean;
  setAuth: (token: string, user: AuthUser) => void;
  clearAuth: () => void;
  setInitialized: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  isAuthenticated: false,
  isInitialized: false,

  setAuth: (token, user) =>
    set({ accessToken: token, user, isAuthenticated: true }),

  clearAuth: () => {
    // `hpm:` 접두사 = 로그인 세션에 묶인 화면 상태(useSessionState). 세션과 무관한 값(예: lib/chunk-recovery.ts의
    // 복구 쿨다운)은 이 접두사를 쓰지 않는다 — 로그인 전 화면도 refresh 실패로 매 로드 여기를 지난다
    try {
      Object.keys(sessionStorage)
        .filter((k) => k.startsWith('hpm:'))
        .forEach((k) => sessionStorage.removeItem(k));
    } catch (err) {
      console.warn('[auth-store] sessionStorage cleanup failed', err);
    }
    set({ accessToken: null, user: null, isAuthenticated: false });
  },

  setInitialized: () => set({ isInitialized: true }),
}));
